import {useState} from 'react'
import {BasicBreadcrumbs} from 'src/app/shared/BasicBreadcrumbs'
import {PartnerContext} from './PartnerContexts'
import {Vista} from './asignaicontablaInterface'
import {DocumentTrayTabs} from './components/DocumentTrayTabs'

const Breadcrumbs = [
  {
    title: 'Seguridad',
    path: '/seguridad/asignaciontabla',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const DataVista: Vista = {
  _id: '',
  nombre: '',
  url: '',
  contenido: '',
  id_empresa: '',
  estado: true,
}

const AsignacionTablaPage = () => {
  const [searchTerm, setSearchTerm] = useState('')
  const [vistaData, setVistaData] = useState<Vista>(DataVista)
  const [edit, setEdit] = useState(false)
  const [reloadTable, setReloadTable] = useState(false)
  const [tabUnitRole, setTabUnitRole] = useState({
    companyId: '',
  })

  return (
    <>
      <PartnerContext.Provider
        value={{
          searchTerm,
          setSearchTerm,
          vistaData,
          setVistaData,
          edit,
          setEdit,
          reloadTable,
          setReloadTable,
          tabUnitRole,
          setTabUnitRole,
        }}
      >
        <BasicBreadcrumbs breadcrumbs={Breadcrumbs} fallbackTitle='Asignación de Tablas' />
        <DocumentTrayTabs />
      </PartnerContext.Provider>
    </>
  )
}

export {AsignacionTablaPage}
